import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetCommunityPostsQuery } from '../../data/queries/get-community-posts.query'
import { GetCommunityChannelsQuery } from '../../data/queries/get-community-channels.query'
import { GetCommunityTotalsQuery } from '../../data/queries/get-community-totals.query'
import {
  type CommunityPostsPageEntity,
  type CommunityChannelEntity,
  type CommunityTotalsEntity
} from '../../data/entities/community.entity'
import { CommunityEntityToCommunityResponseMapper } from '../mappers/community.mappers'
import { type CommunityResponse, type GetCommunityParams } from '../models/community'

export class GetCommunityInteractor {
  private readonly mapper = new CommunityEntityToCommunityResponseMapper()

  constructor(
    private readonly getCommunityPosts: GetInteractor<CommunityPostsPageEntity>,
    private readonly getCommunityChannels: GetInteractor<CommunityChannelEntity[]>,
    private readonly getCommunityTotals: GetInteractor<CommunityTotalsEntity>
  ) {}

  public async execute(params: GetCommunityParams): Promise<CommunityResponse> {
    const offset = (params.postsPage - 1) * params.pageSize

    const [postsResult, channelsResult, totalsResult] = await Promise.all([
      this.getCommunityPosts.execute(
        new GetCommunityPostsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.sortByPosts,
          params.sortOrderPosts,
          offset,
          params.pageSize,
          params.organization
        )
      ),
      this.getCommunityChannels.execute(
        new GetCommunityChannelsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.sortByChannels,
          params.sortOrderChannels,
          params.organization
        )
      ),
      this.getCommunityTotals.execute(
        new GetCommunityTotalsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.organization
        )
      )
    ])

    return this.mapper.map({
      posts: postsResult,
      channels: channelsResult,
      totals: totalsResult
    })
  }
}
